import {
  useNavigate,
  useLocation,
  useParams,
  useSearchParams as useReactRouterSearchParams,
} from "react-router-dom";

type NavOptions = { scroll?: boolean };

/** Next.js-shaped router helpers for the Vite SPA. */
export function useRouter() {
  const navigate = useNavigate();
  return {
    push: (to: string, _opts?: NavOptions) => {
      void navigate(to);
    },
    replace: (to: string, _opts?: NavOptions) => {
      void navigate(to, { replace: true });
    },
    back: () => {
      void navigate(-1);
    },
    prefetch: (_to?: string) => {
      /* no-op in SPA */
    },
  };
}

export function usePathname(): string {
  return useLocation().pathname;
}

/** Matches Next.js: returns URLSearchParams (not the RR tuple). */
export function useSearchParams(): URLSearchParams {
  const [params] = useReactRouterSearchParams();
  return params;
}

export { useParams };

/** Not used at runtime after migrate script rewrites redirect pages. */
export function redirect(_to: string): never {
  throw new Error("redirect() is not supported in Vite admin — use <Navigate />");
}
